import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AdminDashboard from './AdminDashboard';
import SupervisorDashboard from './SupervisorDashboard';
import ControllerDashboard from './ControllerDashboard';
import InterviewerDashboard from './InterviewerDashboard';
import CatiInterviewerDashboard from './CatiInterviewerDashboard';
import RespAdminDashboard from './RespAdminDashboard';
import RespCatiDashboard from './RespCatiDashboard';
import RespControleDashboard from './RespControleDashboard';
import ChefTerrainSuperieurDashboard from './ChefTerrainSuperieurDashboard';
import AdminItDashboard from './AdminItDashboard';
import ChargeEtudeSuperieurDashboard from './ChargeEtudeSuperieurDashboard';
import ChargeEtudeDashboard from './ChargeEtudeDashboard';
import ErrorPage from '../ErrorPage';

const Dashboard = () => {
  const { user } = useAuth();

  const renderDashboard = () => {
    switch (user?.role) {
      case 'administrateur_general_superieur':
      case 'administrateur_general':
        return <AdminDashboard />;
      case 'admin_it':
        return <AdminItDashboard />;
      case 'resp_admin':
        return <RespAdminDashboard />;
      case 'resp_cati':
      case 'supervisor_cati':
        return <RespCatiDashboard />;
      case 'resp_controle':
        return <RespControleDashboard />;
      // Chef terrain sees the same dashboard as his supérieur: the endpoints behind it
      // (cati/surveys/progress, terminate/reactivate-progress) already allow chef_terrain.
      case 'chef_terrain_superieur':
      case 'chef_terrain':
        return <ChefTerrainSuperieurDashboard />;
      case 'charge_etude_superieur':
        return <ChargeEtudeSuperieurDashboard />;
      case 'charge_etude':
        return <ChargeEtudeDashboard />;
      case 'superviseur':
        return <SupervisorDashboard />;
      case 'controleur':
        return <ControllerDashboard />;
      case 'enqueteur':
        // Check if the interviewer is a CATI interviewer
        if (user?.is_cati) {
          return <CatiInterviewerDashboard />;
        }
        return <InterviewerDashboard />;
      default:
        return <ErrorPage />; // Default fallback for unrecognized roles
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 relative overflow-hidden">
      {/* Dotted Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #dc2626 1px, transparent 1px)',
          backgroundSize: '20px 20px'
        }}></div>
      </div>

      {/* Main Content */}
      <main className="relative z-10">
        {renderDashboard()}
      </main>
    </div>
  );
};

export default Dashboard;